export function getItemModText(type: 'both' | 'cuboh_main_item' | 'cuboh_modifier') {
  if (type === 'both') return 'items and modifiers';
  if (type === 'cuboh_main_item') return 'items';
  if (type === 'cuboh_modifier') return 'modifiers';
  return '';
}
